/** A real linked document is required; a checksum or category-only match is not enough. */
export const linkedReviewDocument = (statement, transaction) =>
  statement?.expenses?.find(item => item.checksum && item.checksum === transaction?.checksum && !item._is_deleted) || null;

/** Explicit document nature wins over legacy card labels and statement defaults. */
export const reviewDocumentNature = (statement, transaction, document) => {
  if (!document) return null;
  const nature = document.transaction_type || document.json?.transaction_type || transaction?.json?.transaction_type || transaction?.transaction_type;
  if (nature) return nature;
  const legacyType = document.json?.type || document.type || transaction?.json?.type;
  if (['expense_invoice', 'personal-card', 'receipt'].includes(legacyType)) return 'expense_invoice';
  if (['invoice', 'p-card'].includes(legacyType)) return 'invoice';
  if (legacyType) return null;
  return statement?.default_transaction_type || (statement?.card_type === 'personal-card' ? 'expense_invoice' : statement?.card_type === 'p-card' ? 'invoice' : null);
};

/** Keep processing and already-submitted records out of either editable review flow. */
export const canReviewCardDocument = (statement, transaction, document) => Boolean(
  document && !transaction?.submitted && !transaction?.invoice_id
  && !['Pending', 'Processing'].includes(document.status) && statement?.status !== 'Processing'
);

export const linkedReviewExpense = (statement, transaction) => {
  const document = linkedReviewDocument(statement, transaction);
  return reviewDocumentNature(statement, transaction, document) === 'expense_invoice' ? document : null;
};

export const canReviewCardExpense = (statement, transaction) =>
  canReviewCardDocument(statement, transaction, linkedReviewExpense(statement, transaction));
